import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { signOut, resendVerification } from '../../store/actions/users';

const COOLDOWN = 60;

const NotVerified = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const expired = location.state?.expired ?? false;
    const [loading, setLoading] = useState(false);
    const [cooldown, setCooldown] = useState(0);

    useEffect(() => {
        if (cooldown <= 0) return;
        const timer = setTimeout(() => setCooldown(c => c - 1), 1000);
        return () => clearTimeout(timer);
    }, [cooldown]);

    const handleSignOut = async () => {
        await dispatch(signOut());
        navigate('/account/login');
    };

    const handleResend = async () => {
        setLoading(true);
        try {
            await dispatch(resendVerification()).unwrap();
            setCooldown(COOLDOWN);
        } catch {
            // error toast handled in action
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="not-verified-page">
            <div className="not-verified-card">
                <div className="not-verified-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <h2 className="not-verified-title">
                    {expired ? 'Overovací odkaz vypršal' : 'Overte svoju emailovú adresu'}
                </h2>
                <p className="not-verified-text">
                    {expired
                        ? 'Odkaz na overenie účtu je platný iba 24 hodín a jeho platnosť vypršala.'
                        : <>Prístup k aplikácii je dostupný až po overení účtu.<br />Skontrolujte svoju emailovú schránku a kliknite na overovací odkaz, ktorý sme vám zaslali pri registrácii.</>
                    }
                </p>
                <p className="not-verified-hint">
                    {expired
                        ? 'Nechajte si zaslať nový overovací email pomocou tlačidla nižšie.'
                        : <>Overovací odkaz je platný <strong>24 hodín</strong>.<br />Ak email nevidíte, skontrolujte priečinok Spam alebo Hromadná pošta.</>
                    }
                </p>
                <div className="not-verified-actions">
                    <button
                        className="btn-custom-small"
                        onClick={handleResend}
                        disabled={loading || cooldown > 0}
                    >
                        {loading
                            ? 'Odosiela sa…'
                            : cooldown > 0
                                ? `Znovu odoslať (${cooldown}s)`
                                : 'Zaslať email znovu'}
                    </button>
                    <button className="btn-custom-small not-verified-signout" onClick={handleSignOut}>
                        Odhlásiť sa
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotVerified;
